(function() {
    'use strict';
  
    // Address Validator Variables
    let addressData = [];
    
    // Get theme settings (available via window.themeVariables or meta tag)
    function getThemeSettings() {
        // Try to get from window.themeVariables first
      if (window.themeVariables && window.themeVariables.settings) {
            return window.themeVariables.settings;
      }
        
        // Fallback: try to parse from meta tag if available
      const settingsMeta = document.querySelector('meta[name="theme-settings"]');
      if (settingsMeta) {
            try {
                const settings = JSON.parse(settingsMeta.content);
                return settings;
                } catch (e) {
                    // Could not parse theme settings from meta tag
      }
    }
  
        return {};
    }
  
    // Get address validator page URL from settings
    function getValidatorPageUrl() {
        const settings = getThemeSettings();
        // Support both camelCase and snake_case
        const pageUrl = settings.addressValidatorPage || settings.address_validator_page;
        if (pageUrl) {
            // If it's a page object, get the URL
            if (typeof pageUrl === 'object' && pageUrl.url) {
                return pageUrl.url;
            }
            // If it's already a URL string, return as-is
            if (typeof pageUrl === 'string') {
                return pageUrl;
            }
        }
        return null;
    }
    
    // Check if address validator is enabled
    function isAddressValidatorEnabled() {
        const settings = getThemeSettings();
        // Support both camelCase and snake_case
        return settings.addressValidatorEnabled === true || settings.address_validator_enabled === true;
    }
    
    // Initialize checkout interception for cart drawer
    function initCheckoutInterception() {
        if (!isAddressValidatorEnabled()) {
            return; // Validation is disabled, let checkout proceed normally
        }
        
      const validatorPageUrl = getValidatorPageUrl();
        if (!validatorPageUrl) {
            return;
        }
  
        function setupCheckoutInterception() {
            // Try multiple selectors: custom element, ID, or class
            const cartDrawer = document.querySelector('cart-drawer') || 
                              document.getElementById('cart-drawer') || 
                              document.getElementById('CartDrawer') ||
                              document.querySelector('.cart-drawer');
            
            if (!cartDrawer) {
                return;
            }
            
            // Reset checkout button state when setting up
            const checkoutButton = cartDrawer.querySelector('button[name="checkout"]') ||
                                  document.querySelector('#CartDrawer-Checkout');
            
            if (checkoutButton) {
                resetCheckoutButton(checkoutButton);
            }
            
            // Listen for form submit events on the cart drawer form
            const cartForm = cartDrawer.querySelector('form.cart-drawer__form') || 
                           cartDrawer.querySelector('#CartDrawer-Form') || 
                           cartDrawer.querySelector('form') ||
                           document.querySelector('#CartDrawer-Form');
            
            if (cartForm) {
                // Remove existing listener if any
                cartForm.removeEventListener('submit', handleCartFormSubmit);
                cartForm.addEventListener('submit', handleCartFormSubmit);
            }
            
            // Also intercept button clicks directly
            if (checkoutButton) {
                checkoutButton.removeEventListener('click', handleCheckoutButtonClick);
                checkoutButton.addEventListener('click', handleCheckoutButtonClick, true); // Use capture phase
            }
        }
  
      function resetCheckoutButton(button) {
            if (button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
        button.classList.remove('is-loading', 'loading');
            }
      }
  
        function handleCartFormSubmit(e) {
            const form = e.target;
            const checkoutButton = form.querySelector('button[name="checkout"]');
            
            if (checkoutButton && checkoutButton.type === 'submit') {
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                resetCheckoutButton(checkoutButton);
                // Redirect to validator page
                window.location.href = validatorPageUrl;
                return false;
            }
        }
        
        function handleCheckoutButtonClick(e) {
            const checkoutButton = e.target.closest('button[name="checkout"]') || e.target;
            
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            resetCheckoutButton(checkoutButton);
            // Redirect to validator page
            window.location.href = validatorPageUrl;
            return false;
        }
        
        // Try to setup immediately
        setupCheckoutInterception();
        
        // Also try to setup when DOM is fully loaded
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function() {
                setupCheckoutInterception();
            });
        }
        
        // Retry setup after a short delay (in case cart drawer loads asynchronously)
        setTimeout(function() {
            setupCheckoutInterception();
        }, 1000);
        
        // Find cart drawer element (try multiple selectors)
        function findCartDrawer() {
            return document.querySelector('cart-drawer') || 
                   document.getElementById('cart-drawer') || 
                   document.getElementById('CartDrawer') ||
                   document.querySelector('.cart-drawer');
        }
        
        const cartDrawer = findCartDrawer();
        
        if (cartDrawer) {
            // Reset checkout button when cart drawer opens
            cartDrawer.addEventListener('transitionend', function() {
                setupCheckoutInterception();
            });
            
            // Listen for when drawer becomes active
            const observer = new MutationObserver(function(mutations) {
                if (cartDrawer.classList.contains('active')) {
                    setupCheckoutInterception();
                }
            });
            
            observer.observe(cartDrawer, {
                attributes: true,
                attributeFilter: ['class']
            });
        }
        
        // Re-setup interception when cart updates (listen on document for cart-drawer custom element)
        const globalObserver = new MutationObserver(function(mutations) {
            const drawer = findCartDrawer();
            if (drawer) {
                setupCheckoutInterception();
            }
        });
        
        globalObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
        
        // Also listen for cart update events
        document.addEventListener('cart:updated', function() {
            setTimeout(setupCheckoutInterception, 100);
        });
    }
    
    // Initialize address validator form (for page)
    function initAddressValidatorForm() {
        const form = document.getElementById('address-validator-form');
        if (!form) {
            // Form not on this page, skip initialization
            return;
        }
        
        // Initialize address dropdown (non-searchable)
        const savedAddressSelect = document.getElementById('address-validator-saved-address');
        if (savedAddressSelect) {
            initAddressDropdown('address-validator-saved-address-search', 'address-validator-saved-address', 'address-validator-saved-address-list');
            populateAddressDropdown();
        }
        // Initialize searchable dropdowns (province and ward)
        initSearchableDropdown('address-validator-province-search', 'address-validator-province-select', 'address-validator-province-list');
        initSearchableDropdown('address-validator-ward-search', 'address-validator-ward-select', 'address-validator-ward-list');
        
        // Load address data from API
        loadAddressData();
        
        // Setup form handlers
        setupFormHandlers();
    }
    
    // Load address data from Sheety API
    function loadAddressData() {
        fetch('https://api.sheety.co/5530b81b3883ada579057862e944b50e/jaspalVietnamAddressDb/newAddress')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                addressData = data.newAddress || [];
                populateProvinceDropdown();
                // Auto-select first address on load if dropdown exists
                autoSelectFirstAddress();
            })
            .catch(error => {
                // Error loading address data
            });
    }
    
    // Helper function to find input element by name
    function findInputByName(name) {
      const form = document.getElementById('address-validator-form');
        if (!form) return null;
        return form.querySelector(`input[name="${name}"]`);
    }
  
    // Helper function to find postal code input by ID
    function findPostalCodeInput() {
      return document.querySelector('#address-postal-code');
    }
  
    // Helper: Show all dropdown items and display dropdown
    function showAllDropdownItems(list) {
        const items = list.querySelectorAll('.searchable-dropdown-item');
        items.forEach(item => item.classList.remove('hidden'));
        list.style.display = 'block';
    }
    
    // Validate searchable dropdown input - check if value matches a valid option
    function validateSearchableDropdownInput(searchInputId, selectId) {
        const searchInput = document.getElementById(searchInputId);
        const select = document.getElementById(selectId);
        
        if (!searchInput || !select) return false;
        
        const inputValue = searchInput.value.trim();
        const selectValue = select.value;
        
        // If input is empty, validation will be handled by form validation
        if (inputValue === '') {
            return selectValue === '';
        }
        
        // Check if select value exists in options
        const options = Array.from(select.options);
        const selectedOption = options.find(opt => opt.value === selectValue && !opt.disabled && opt.value !== '');
        
        // If select has no valid value, it's invalid
        if (!selectedOption) {
            // Determine field name based on select ID
            let fieldName = '';
            if (selectId === 'address-validator-province-select') {
                fieldName = 'select[name="address[province]"]';
            } else if (selectId === 'address-validator-ward-select') {
                fieldName = 'select[name="address[ward]"]';
            }
            
            if (fieldName) {
                showFieldError(fieldName, 'Please select an item from the list');
            }
            return false;
        }
        
        // Check if input value matches the selected option text (case-insensitive)
        const optionText = selectedOption.textContent.trim().toLowerCase();
        const inputText = inputValue.toLowerCase();
        
        if (optionText !== inputText) {
            // Input doesn't match selected option - invalid
            let fieldName = '';
            if (selectId === 'address-validator-province-select') {
                fieldName = 'select[name="address[province]"]';
            } else if (selectId === 'address-validator-ward-select') {
                fieldName = 'select[name="address[ward]"]';
            }
            
            if (fieldName) {
                showFieldError(fieldName, 'Please select an item from the list');
            }
            return false;
        }
        
        // Clear error if valid
        clearFieldErrorForSearchableDropdown(searchInputId, selectId);
        return true;
    }
    
    // Validate that select value exists in valid options (for autofill protection)
    function validateSelectValueExists(selectId) {
        const select = document.getElementById(selectId);
        if (!select) return false;
        
        const selectValue = select.value;
        if (!selectValue || selectValue === '') return false;
        
        const options = Array.from(select.options);
        const validOption = options.find(opt => 
            opt.value === selectValue && 
            !opt.disabled && 
            opt.value !== ''
        );
        
        return !!validOption;
    }
    
    // Clear field error for searchable dropdown
    function clearFieldErrorForSearchableDropdown(searchInputId, selectId) {
        const select = document.getElementById(selectId);
        if (!select) return;
        
        // Determine field name based on select ID
        let fieldName = '';
        if (selectId === 'address-validator-province-select') {
            fieldName = 'select[name="address[province]"]';
        } else if (selectId === 'address-validator-ward-select') {
            fieldName = 'select[name="address[ward]"]';
        }
        
        if (fieldName) {
            clearFieldError(fieldName);
        }
    }
    
    // Initialize searchable dropdown
    function initSearchableDropdown(searchInputId, selectId, listId) {
        const searchInput = document.getElementById(searchInputId);
        const select = document.getElementById(selectId);
        const list = document.getElementById(listId);
        
        if (!searchInput || !select || !list) return;
        
        // Show/hide dropdown on focus/blur - show all items (no filtering)
        searchInput.addEventListener('focus', function() {
            showAllDropdownItems(list);
        });
        
        // Also show dropdown on click (for readonly inputs)
        searchInput.addEventListener('click', function() {
            showAllDropdownItems(list);
        });
        
        searchInput.addEventListener('blur', function() {
            // Delay hiding to allow click on list item
            setTimeout(() => {
                list.style.display = 'none';
                
                // Validate if input value matches a valid option
                validateSearchableDropdownInput(searchInputId, selectId);
            }, 200);
        });
        
        // Handle input - keep all items visible for typeahead
        let autofillCheckTimeout;
        searchInput.addEventListener('input', function() {
            if (!this.readOnly) {
                // Keep all items visible (no filtering)
                showAllDropdownItems(list);
                
                // Clear hidden select if search input is empty
                if (searchInput.value.trim() === '') {
                    select.value = '';
                    select.selectedIndex = 0;
                } else {
                    // Clear error when user starts typing (will be validated on blur)
                    clearFieldErrorForSearchableDropdown(searchInputId, selectId);
                }
            }
            
            // Check for autofill - validate after a delay
            if (autofillCheckTimeout) {
                clearTimeout(autofillCheckTimeout);
            }
            
            autofillCheckTimeout = setTimeout(() => {
                // If input has value, validate it matches a valid option
                if (searchInput.value.trim() !== '') {
                    validateSearchableDropdownInput(searchInputId, selectId);
                }
            }, 500);
        });
        
        // Handle selection from list
        list.addEventListener('click', function(e) {
            const item = e.target.closest('.searchable-dropdown-item');
            if (item) {
                const value = item.getAttribute('data-value');
                const text = item.textContent;
                
                // Update search input
                searchInput.value = text;
                
                // Update hidden select
                select.value = value;
                select.selectedIndex = Array.from(select.options).findIndex(opt => opt.value === value);
                
                // Clear any validation errors since valid option was selected
                clearFieldErrorForSearchableDropdown(searchInputId, selectId);
                
                // Trigger change event
                select.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Hide dropdown
                list.style.display = 'none';
            }
        });
        
        // Apply typeahead functionality
        applyTypeaheadToDropdown(searchInputId, selectId, listId);
        
        // Handle autofill events - validate when autofill occurs
        searchInput.addEventListener('change', function() {
            // Validate on change (autofill triggers change event)
            setTimeout(() => {
                validateSearchableDropdownInput(searchInputId, selectId);
            }, 100);
        });
        
        // Also validate when hidden select value changes (in case autofill sets it directly)
        select.addEventListener('change', function() {
            // If select has value but input doesn't match, validate
            if (this.value && this.value !== '') {
                setTimeout(() => {
                    validateSearchableDropdownInput(searchInputId, selectId);
                }, 100);
            }
        });
    }
    
    // Initialize address dropdown (non-searchable, shows all items)
    function initAddressDropdown(searchInputId, selectId, listId) {
        const searchInput = document.getElementById(searchInputId);
        const select = document.getElementById(selectId);
        const list = document.getElementById(listId);
        
        if (!searchInput || !select || !list) return;
        
        // Show/hide dropdown on focus/blur
        searchInput.addEventListener('focus', function() {
            showAllDropdownItems(list);
        });
        
        // Also show dropdown on click
        searchInput.addEventListener('click', function() {
            showAllDropdownItems(list);
        });
        
        searchInput.addEventListener('blur', function() {
            // Delay hiding to allow click on list item
            setTimeout(() => {
                list.style.display = 'none';
            }, 200);
        });
        
        // Handle selection from list
        list.addEventListener('click', function(e) {
            const item = e.target.closest('.searchable-dropdown-item');
            if (item) {
                const value = item.getAttribute('data-value');
                const text = item.textContent;
                
                // Update search input
                searchInput.value = text;
                
                // Update hidden select
                select.value = value;
                select.selectedIndex = Array.from(select.options).findIndex(opt => opt.value === value);
                
                // Trigger change event
                select.dispatchEvent(new Event('change', { bubbles: true }));
                
                // Hide dropdown
                list.style.display = 'none';
            }
        });
    }
    
    // Typeahead: Find first matching option in dropdown list
    function findMatchingDropdownItem(list, searchText) {
        if (!list || !searchText) return null;
        
        const items = list.querySelectorAll('.searchable-dropdown-item:not(.hidden)');
        const searchLower = searchText.toLowerCase();
        
        // Find first item that contains the search text (case-insensitive, anywhere in text)
        for (let i = 0; i < items.length; i++) {
            const itemText = items[i].textContent.toLowerCase();
            if (itemText.includes(searchLower)) {
                return items[i];
            }
        }
        
        return null;
    }
    
    // Typeahead: Highlight and scroll to matching item
    function highlightDropdownItem(list, item) {
        if (!list || !item) return;
        
        // Remove highlight from all items
        const allItems = list.querySelectorAll('.searchable-dropdown-item');
        allItems.forEach(i => i.classList.remove('highlighted'));
        
        // Add highlight to matching item
        item.classList.add('highlighted');
        
        // Scroll item into view
        try {
            item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (e) {
            // Fallback if scrollIntoView fails
            item.scrollIntoView(false);
        }
    }
    
    // Typeahead: Apply typeahead to searchable dropdown
    function applyTypeaheadToDropdown(searchInputId, selectId, listId) {
        const searchInput = document.getElementById(searchInputId);
        const select = document.getElementById(selectId);
        const list = document.getElementById(listId);
        
        if (!searchInput || !select || !list) return;
        
        // Handle keydown for keyboard navigation
        searchInput.addEventListener('keydown', function(e) {
            // If dropdown is not visible, don't handle typeahead
            if (list.style.display === 'none') {
                return;
            }
            
            // Handle special keys
            if (e.key === 'Enter') {
                e.preventDefault();
                // Select the highlighted item
                const highlighted = list.querySelector('.searchable-dropdown-item.highlighted');
                if (highlighted) {
                    highlighted.click();
                } else {
                    // If no highlighted item, select first visible item
                    const firstItem = list.querySelector('.searchable-dropdown-item:not(.hidden)');
                    if (firstItem) {
                        firstItem.click();
                    }
                }
                return;
            }
            
            if (e.key === 'Escape') {
                list.style.display = 'none';
                return;
            }
            
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                // Navigate to next item
                const items = Array.from(list.querySelectorAll('.searchable-dropdown-item:not(.hidden)'));
                const currentIndex = items.findIndex(item => item.classList.contains('highlighted'));
                const nextIndex = currentIndex < items.length - 1 ? currentIndex + 1 : 0;
                if (items[nextIndex]) {
                    highlightDropdownItem(list, items[nextIndex]);
                } else if (items.length > 0 && currentIndex === -1) {
                    // If nothing is highlighted, highlight first item
                    highlightDropdownItem(list, items[0]);
                }
                return;
            }
            
            if (e.key === 'ArrowUp') {
                e.preventDefault();
                // Navigate to previous item
                const items = Array.from(list.querySelectorAll('.searchable-dropdown-item:not(.hidden)'));
                const currentIndex = items.findIndex(item => item.classList.contains('highlighted'));
                const prevIndex = currentIndex > 0 ? currentIndex - 1 : items.length - 1;
                if (items[prevIndex]) {
                    highlightDropdownItem(list, items[prevIndex]);
                } else if (items.length > 0 && currentIndex === -1) {
                    // If nothing is highlighted, highlight last item
                    highlightDropdownItem(list, items[items.length - 1]);
                }
                return;
            }
        });
        
        // Handle input changes for typeahead matching
        searchInput.addEventListener('input', function() {
            const searchValue = this.value.toLowerCase().trim();
            
            // Find matching item based on current input value
            if (searchValue.length > 0) {
                const matchingItem = findMatchingDropdownItem(list, searchValue);
                if (matchingItem) {
                    highlightDropdownItem(list, matchingItem);
                } else {
                    // Clear highlight if no match
                    const highlighted = list.querySelector('.searchable-dropdown-item.highlighted');
                    if (highlighted) {
                        highlighted.classList.remove('highlighted');
                    }
                }
            } else {
                // Clear highlight if input is empty
                const highlighted = list.querySelector('.searchable-dropdown-item.highlighted');
                if (highlighted) {
                    highlighted.classList.remove('highlighted');
                }
            }
        });
    }
    
    // Populate province/city dropdown
    function populateProvinceDropdown() {
        const provinceSelect = document.getElementById('address-validator-province-select');
        const provinceList = document.getElementById('address-validator-province-list');
      if (!provinceSelect || !addressData.length) return;
  
        // Get unique provinces
      const provinces = [...new Set(addressData.map(item => item['province/city']))].sort();
        
        // Clear existing options except the placeholder
      provinceSelect.innerHTML = '<option value="" selected disabled>Select province</option>';
        if (provinceList) {
            provinceList.innerHTML = '';
        }
        
        // Add province options to both hidden select and searchable list
        provinces.forEach(province => {
            // Add to hidden select
            const option = document.createElement('option');
            option.value = province;
            option.textContent = province;
            provinceSelect.appendChild(option);
            
            // Add to searchable list
            if (provinceList) {
                const listItem = document.createElement('div');
                listItem.className = 'searchable-dropdown-item';
                listItem.textContent = province;
                listItem.setAttribute('data-value', province);
                provinceList.appendChild(listItem);
            }
        });
    }
    
    // Populate address dropdown list from select options
    function populateAddressDropdown() {
        const savedAddressSelect = document.getElementById('address-validator-saved-address');
        const addressList = document.getElementById('address-validator-saved-address-list');
        if (!savedAddressSelect || !addressList) return;
        
        // Clear existing list items
        addressList.innerHTML = '';
        
        // Populate list from select options (skip the first placeholder option)
        for (let i = 1; i < savedAddressSelect.options.length; i++) {
            const option = savedAddressSelect.options[i];
            const listItem = document.createElement('div');
            listItem.className = 'searchable-dropdown-item';
            listItem.textContent = option.textContent;
            listItem.setAttribute('data-value', option.value);
            addressList.appendChild(listItem);
        }
    }
    
    // Auto-select first address on page load
    function autoSelectFirstAddress() {
        const savedAddressSelect = document.getElementById('address-validator-saved-address');
        const savedAddressSearchInput = document.getElementById('address-validator-saved-address-search');
        if (!savedAddressSelect) return;
        
        // Check if there are any address options (more than just the placeholder)
        // The first option is the placeholder, so we need at least 2 options
        if (savedAddressSelect.options.length > 1) {
            // Select the first actual address option (index 1, since index 0 is the placeholder)
            const firstOption = savedAddressSelect.options[1];
            savedAddressSelect.selectedIndex = 1;
            
            // Update search input
            if (savedAddressSearchInput) {
                savedAddressSearchInput.value = firstOption.textContent;
            }
            
            // Trigger change event to prefill all fields
            savedAddressSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    
    // Filter wards based on selected province
    function filterWards(province) {
        const wardSelect = document.getElementById('address-validator-ward-select');
        const wardList = document.getElementById('address-validator-ward-list');
        const wardSearchInput = document.getElementById('address-validator-ward-search');
      if (!wardSelect) return;
        
        // Clear existing options
      wardSelect.innerHTML = '<option value="" selected disabled>Select ward</option>';
        if (wardList) {
            wardList.innerHTML = '';
        }
        
        if (!province) {
            if (wardSearchInput) {
                wardSearchInput.disabled = true;
                wardSearchInput.value = '';
            }
            return;
        }
        
        // Filter wards for selected province
      const wards = addressData
        .filter(item => item['province/city'] === province)
        .map(item => item['ward/commune'])
            .filter((value, index, self) => self.indexOf(value) === index)
        .sort();
  
        // Populate ward dropdown
        wards.forEach(ward => {
            // Add to hidden select
            const option = document.createElement('option');
            option.value = ward;
            option.textContent = ward;
            wardSelect.appendChild(option);
            
            // Add to searchable list
            if (wardList) {
                const listItem = document.createElement('div');
                listItem.className = 'searchable-dropdown-item';
                listItem.textContent = ward;
                listItem.setAttribute('data-value', ward);
                wardList.appendChild(listItem);
            }
        });
        
        if (wardSearchInput) {
            wardSearchInput.disabled = false;
            wardSearchInput.removeAttribute('readonly');
            wardSearchInput.style.cursor = 'text';
        }
    }
    
    // Auto-fill postal code based on province and ward
    function autoFillPostalCode(province, ward) {
        const postalCodeInput = findPostalCodeInput();
        if (!postalCodeInput || !province || !ward) {
            if (postalCodeInput) {
                postalCodeInput.value = '';
            }
            return;
        }
        
        // Find matching postal code
        const match = addressData.find(item => 
            item['province/city'] === province && 
            item['ward/commune'] === ward
        );
        
        if (match && match.postalCode) {
            postalCodeInput.value = match.postalCode;
        } else {
            postalCodeInput.value = '';
        }
    }
    
    // Setup form event handlers
    function setupFormHandlers() {
        const form = document.getElementById('address-validator-form');
        if (!form) return;
        
        // Handle saved address dropdown (if exists)
        const savedAddressSelect = document.getElementById('address-validator-saved-address');
        const savedAddressSearchInput = document.getElementById('address-validator-saved-address-search');
        if (savedAddressSelect) {
            savedAddressSelect.addEventListener('change', async function() {
                const selectedOption = this.options[this.selectedIndex];
                
                // Update search input with selected value
                if (savedAddressSearchInput && selectedOption) {
                    if (selectedOption.value) {
                        savedAddressSearchInput.value = selectedOption.textContent;
                    } else {
                        savedAddressSearchInput.value = '';
                    }
                }
                
                if (selectedOption && selectedOption.value) {
                    // Get address data from data attributes
                    const address1 = selectedOption.value || '';
                    const firstName = selectedOption.getAttribute('data-first-name') || '';
                    const lastName = selectedOption.getAttribute('data-last-name') || '';
                    const address2 = selectedOption.getAttribute('data-address2') || '';
                    const city = selectedOption.getAttribute('data-city') || '';
                    const province = selectedOption.getAttribute('data-province') || '';
                    const zip = selectedOption.getAttribute('data-zip') || '';
                    
                    // Fill street address input field
                    const streetAddressInput = form.querySelector('input[name="address[address1]"]');
                    if (streetAddressInput && address1) {
                        streetAddressInput.value = address1;
                    }
                    
                    // Fill first name and last name if available
                    const firstNameInput = findInputByName('contact[first_name]');
                    const lastNameInput = findInputByName('contact[last_name]');
                    if (firstNameInput && firstName) {
                        firstNameInput.value = firstName;
                    }
                    if (lastNameInput && lastName) {
                        lastNameInput.value = lastName;
                    }
                    
                    // Use city if province is empty (since city and province are similar)
                    const provinceToMatch = province || city;
                    
                    // Handle province, ward, and postal code matching with Sheety API
                    const provinceSelect = document.getElementById('address-validator-province-select');
                    const provinceSearchInput = document.getElementById('address-validator-province-search');
                    const wardSelect = document.getElementById('address-validator-ward-select');
                    const wardSearchInput = document.getElementById('address-validator-ward-search');
                    const postalCodeInput = findPostalCodeInput();
                    
                    // Reset province, ward, and postal code first
                    if (provinceSelect) {
                        provinceSelect.value = '';
                        provinceSelect.selectedIndex = 0;
                    }
                    if (provinceSearchInput) {
                        provinceSearchInput.value = '';
                    }
                    if (wardSelect) {
                        wardSelect.innerHTML = '<option value="" selected disabled>Select ward</option>';
                    }
                    if (wardSearchInput) {
                        wardSearchInput.disabled = true;
                        wardSearchInput.value = '';
                    }
                    if (postalCodeInput) {
                        postalCodeInput.value = '';
                    }
                    
                    // Step 1: Check province first - only proceed if province exists
                    // Use city if province is empty (since city and province are similar)
                    if (!provinceToMatch) {
                        clearAllErrors();
                        return;
                    }
                    
                    if (addressData.length === 0) {
                        clearAllErrors();
                        return;
                    }
                    
                    if (!provinceSelect) {
                        clearAllErrors();
                        return;
                    }
                    
                    // Wait for province dropdown to be populated
                    await new Promise(resolve => setTimeout(resolve, 100));
                    
                    // Find matching province option in the API data
                    // Note: Comparing customer address.province (or city if province empty) against Sheety API province/city
                    const provinceOption = Array.from(provinceSelect.options).find(opt => 
                        opt.value === provinceToMatch || opt.textContent.trim() === provinceToMatch
                    );
                    
                    if (!provinceOption) {
                        clearAllErrors();
                        return;
                    }
                    
                    // Province matches - select it
                    provinceSelect.value = provinceOption.value;
                    
                    // Update search input
                    if (provinceSearchInput) {
                        provinceSearchInput.value = provinceOption.textContent;
                    }
                    
                    // Trigger change to populate wards
                    provinceSelect.dispatchEvent(new Event('change', { bubbles: true }));
                    
                    // Step 2: Check ward - only proceed if ward exists and province matched
                    setTimeout(() => {
                        if (!address2) {
                            clearAllErrors();
                            return;
                        }
                        
                        if (!wardSelect) {
                            clearAllErrors();
                            return;
                        }
                        
                        // Find matching ward option in the filtered wards
                        // Note: Comparing customer address.address2 against Sheety API ward/commune
                        const wardOption = Array.from(wardSelect.options).find(opt => 
                            opt.value === address2 || opt.textContent.trim() === address2
                        );
                        
                        if (!wardOption) {
                            wardSelect.value = '';
                            wardSelect.selectedIndex = 0;
                            if (wardSearchInput) {
                                wardSearchInput.value = '';
                            }
                            if (postalCodeInput) {
                                postalCodeInput.value = '';
                            }
                            clearAllErrors();
                            return;
                        }
                        
                        // Ward matches - select it
                        wardSelect.value = wardOption.value;
                        
                        // Update search input
                        if (wardSearchInput) {
                            wardSearchInput.value = wardOption.textContent;
                        }
                        
                        // Trigger change to auto-fill postal code
                        wardSelect.dispatchEvent(new Event('change', { bubbles: true }));
                        
                        clearAllErrors();
                    }, 200);
                }
            });
        }
        
        // Initialize ward select as disabled
        const wardSelect = document.getElementById('address-validator-ward-select');
        const wardSearchInput = document.getElementById('address-validator-ward-search');
        if (wardSearchInput) {
            wardSearchInput.disabled = true;
        }
        
        // Province change handler
        const provinceSelect = document.getElementById('address-validator-province-select');
        const provinceSearchInput = document.getElementById('address-validator-province-search');
      if (provinceSelect) {
        provinceSelect.addEventListener('change', function() {
                const selectedProvince = this.value;
                const selectedOption = this.options[this.selectedIndex];
                
                // Update search input with selected value
                if (provinceSearchInput && selectedOption && selectedOption.value) {
                    provinceSearchInput.value = selectedOption.textContent;
                }
                
                // Clear ward and postal code when province changes
                const wardSelect = document.getElementById('address-validator-ward-select');
                const wardSearchInput = document.getElementById('address-validator-ward-search');
                if (wardSelect) {
                    wardSelect.value = '';
                    wardSelect.selectedIndex = 0;
                }
                if (wardSearchInput) {
                    wardSearchInput.value = '';
                }
                const postalCodeInput = findPostalCodeInput();
                if (postalCodeInput) {
                    postalCodeInput.value = '';
                }
                
                filterWards(selectedProvince);
                // Clear error when user selects a value
          clearFieldError('select[name="address[province]"]');
        });
      }
  
        // Ward change handler
      if (wardSelect) {
        wardSelect.addEventListener('change', function() {
                const selectedProvince = provinceSelect ? provinceSelect.value : '';
                const selectedWard = this.value;
                const selectedOption = this.options[this.selectedIndex];
                
                // Update search input with selected value
                if (wardSearchInput && selectedOption && selectedOption.value) {
                    wardSearchInput.value = selectedOption.textContent;
                }
                
                autoFillPostalCode(selectedProvince, selectedWard);
                // Clear error when user selects a value
          clearFieldError('select[name="address[ward]"]');
        });
      }
  
        // Real-time character limit validation for first name, last name, and address
        const firstNameInput = form.querySelector('input[name="contact[first_name]"]');
        const lastNameInput = form.querySelector('input[name="contact[last_name]"]');
        const streetAddressInput = form.querySelector('input[name="address[address1]"]');
        
        if (firstNameInput) {
            firstNameInput.addEventListener('input', function() {
                const value = this.value.trim();
                if (value.length > 20) {
                    showFieldError('contact[first_name]', 'First name is too long (maximum is 20 characters)');
                } else if (value.length > 0) {
                    clearFieldError('contact[first_name]');
                }
            });
        }
        
        if (lastNameInput) {
            lastNameInput.addEventListener('input', function() {
                const value = this.value.trim();
                if (value.length > 20) {
                    showFieldError('contact[last_name]', 'Last name is too long (maximum is 20 characters)');
                } else if (value.length > 0) {
                    clearFieldError('contact[last_name]');
                }
            });
        }
        
        if (streetAddressInput) {
            streetAddressInput.addEventListener('input', function() {
                const value = this.value.trim();
                if (value.length > 100) {
                    const fieldControl = this.closest('.form-control');
                    if (fieldControl) {
                        fieldControl.classList.add('has-error');
                        const label = fieldControl.querySelector('label');
                        if (label) {
                            const existingError = label.querySelector('.field-error');
                            if (existingError) {
                                existingError.remove();
                            }
                            const errorElement = document.createElement('span');
                            errorElement.className = 'field-error';
                            errorElement.textContent = 'Address is too long (maximum is 100 characters)';
                            label.appendChild(errorElement);
                        }
                    }
                } else if (value.length > 0) {
                    const fieldControl = this.closest('.form-control');
                    if (fieldControl) {
                        fieldControl.classList.remove('has-error');
                        const errorElement = fieldControl.querySelector('.field-error');
                        if (errorElement) {
                            errorElement.remove();
                        }
                    }
                }
            });
        }
        
        // Clear errors on input/select change
        const formInputs = form.querySelectorAll('input, select');
        formInputs.forEach(input => {
            input.addEventListener('input', function() {
                const fieldName = this.name || this.id;
                if (fieldName) {
                    // Skip character limit fields as they have their own handlers
                    if (fieldName === 'contact[first_name]' || fieldName === 'contact[last_name]' || fieldName === 'address[address1]') {
                        return;
                    }
                    if (this.tagName === 'SELECT') {
                        clearFieldError(`select[name="${fieldName}"]`);
                    } else {
                        clearFieldError(fieldName);
                    }
                }
            });
            
            input.addEventListener('change', function() {
                const fieldName = this.name || this.id;
                if (fieldName) {
                    // Skip character limit fields as they have their own handlers
                    if (fieldName === 'contact[first_name]' || fieldName === 'contact[last_name]' || fieldName === 'address[address1]') {
                        return;
                    }
                    if (this.tagName === 'SELECT') {
                        clearFieldError(`select[name="${fieldName}"]`);
                    } else {
                        clearFieldError(fieldName);
                    }
                }
            });
        });
        
        // Form submit handler
      const submitButton = document.querySelector('#address-validator-submit');
        if (submitButton) {
            submitButton.addEventListener('click', function(e) {
                e.preventDefault();
                validateAndSubmit();
            });
        }
    }
    
    // Clear error for a specific field
    function clearFieldError(fieldName) {
        const form = document.getElementById('address-validator-form');
        if (!form) return;
        
        // Find the field (input or select)
        let field, fieldControl, label;
        if (fieldName.includes('select')) {
            const match = fieldName.match(/select\[name="([^"]+)"/);
            if (match) {
                const name = match[1];
                // For searchable dropdowns, find the wrapper
                if (name === 'address[province]') {
                    field = document.getElementById('address-validator-province-search');
                    if (field) {
                        fieldControl = field.closest('.searchable-dropdown-wrapper');
                        label = fieldControl ? fieldControl.querySelector('label') : null;
                    }
                } else if (name === 'address[ward]') {
                    field = document.getElementById('address-validator-ward-search');
                    if (field) {
                        fieldControl = field.closest('.searchable-dropdown-wrapper');
                        label = fieldControl ? fieldControl.querySelector('label') : null;
                    }
                } else {
                    field = form.querySelector(`select[name="${name}"]`);
                    if (field) {
                        fieldControl = field.closest('.field') || field.closest('.searchable-dropdown-wrapper') || field.parentElement;
                        const parentContainer = fieldControl ? fieldControl.parentElement : null;
                        label = parentContainer ? parentContainer.querySelector('label.field__label') : null;
                    }
                }
            }
        } else {
            field = form.querySelector(`input[name="${fieldName}"]`) || form.querySelector(`#${fieldName}`);
            if (field) {
                fieldControl = field.closest('.field') || field.parentElement;
                const parentContainer = fieldControl ? fieldControl.parentElement : null;
                label = parentContainer ? parentContainer.querySelector('label.field__label') : null;
            }
        }
        
        // Remove error message from label or fieldControl
        if (label) {
            const errorElement = label.querySelector('.field-error');
            if (errorElement) {
                errorElement.remove();
            }
        }
        if (fieldControl) {
            const errorElement = fieldControl.querySelector('.field-error');
            if (errorElement) {
                errorElement.remove();
            }
        }
        
        // Remove error class
        if (fieldControl) {
            fieldControl.classList.remove('has-error');
        }
        if (field) {
            field.classList.remove('has-error');
        }
    }
    
    // Clear all error messages
    function clearAllErrors() {
        const form = document.getElementById('address-validator-form');
        if (!form) return;
        
        // Remove all error messages
        const errorMessages = form.querySelectorAll('.field-error');
        errorMessages.forEach(error => error.remove());
        
        // Remove error classes
        const errorControls = form.querySelectorAll('.field.has-error, .searchable-dropdown-wrapper.has-error');
        errorControls.forEach(control => control.classList.remove('has-error'));
        
        const errorInputs = form.querySelectorAll('.field__input.has-error, input.has-error, select.has-error');
        errorInputs.forEach(input => input.classList.remove('has-error'));
    }
    
    // Show error message for a field
    function showFieldError(fieldName, message) {
        const form = document.getElementById('address-validator-form');
        if (!form) return null;
        
        let field, fieldControl, label;
        
        // Find the field (input or select)
        if (fieldName.includes('select[name=')) {
            // Extract the name from select[name="address[province]"]
            const match = fieldName.match(/select\[name="([^"]+)"/);
            if (match) {
                const name = match[1];
                // For searchable dropdowns, find the wrapper
                if (name === 'address[province]') {
                    field = document.getElementById('address-validator-province-search');
                    if (field) {
                        fieldControl = field.closest('.searchable-dropdown-wrapper');
                        label = fieldControl ? fieldControl.querySelector('label') : null;
                    }
                } else if (name === 'address[ward]') {
                    field = document.getElementById('address-validator-ward-search');
                    if (field) {
                        fieldControl = field.closest('.searchable-dropdown-wrapper');
                        label = fieldControl ? fieldControl.querySelector('label') : null;
                    }
                } else {
                    field = form.querySelector(`select[name="${name}"]`);
                    if (field) {
                        // Find parent container (could be .field or wrapper div)
                        fieldControl = field.closest('.field') || field.closest('.searchable-dropdown-wrapper') || field.parentElement;
                        // Find label - could be sibling or in parent
                        label = fieldControl ? fieldControl.querySelector('label') : null;
                        if (!label && fieldControl) {
                            label = fieldControl.previousElementSibling;
                            if (label && !label.classList.contains('field__label')) {
                                label = null;
                            }
                        }
                    }
                }
            }
        } else {
            field = form.querySelector(`input[name="${fieldName}"]`) || form.querySelector(`#${fieldName}`);
            if (field) {
                // Find parent container - could be .field or parent div
                fieldControl = field.closest('.field') || field.parentElement;
                // Find label - could be sibling (before the .field div) or in parent
                if (fieldControl) {
                    label = fieldControl.previousElementSibling;
                    if (label && label.classList.contains('field__label')) {
                        // Label is sibling before .field div
                    } else {
                        // Try to find label in parent container
                        const parentContainer = fieldControl.parentElement;
                        if (parentContainer) {
                            label = parentContainer.querySelector('label.field__label');
                        }
                    }
                }
            }
        }
        
        if (!field) return null;
        
        // Remove existing error if any
        if (fieldControl) {
            const existingError = fieldControl.querySelector('.field-error');
            if (existingError) {
                existingError.remove();
            }
        }
        if (label) {
            const existingError = label.querySelector('.field-error');
            if (existingError) {
                existingError.remove();
            }
        }
        
        // Add error class to field container
        if (fieldControl) {
            fieldControl.classList.add('has-error');
        }
        if (field) {
            field.classList.add('has-error');
        }
        
        // Create error message element
        const errorElement = document.createElement('span');
        errorElement.className = 'field-error';
        errorElement.textContent = message;
        
        // Insert error message - prefer label, otherwise after field
        if (label) {
            label.appendChild(errorElement);
        } else if (fieldControl) {
            fieldControl.insertBefore(errorElement, fieldControl.firstChild);
        } else {
            field.insertAdjacentElement('afterend', errorElement);
        }
        
        return field;
    }
    
    // Validate form
    function validateForm() {
      const form = document.getElementById('address-validator-form');
      if (!form) return false;
        
        // Clear previous errors
      clearAllErrors();
  
        // Get form values
        const firstNameInput = form.querySelector('input[name="contact[first_name]"]');
        const lastNameInput = form.querySelector('input[name="contact[last_name]"]');
        const emailInput = form.querySelector('input[name="contact[email]"]');
        const streetAddressInput = form.querySelector('input[name="address[address1]"]');
        const provinceSelect = document.getElementById('address-validator-province-select');
        const wardSelect = document.getElementById('address-validator-ward-select');
        
        const firstName = firstNameInput ? firstNameInput.value.trim() : '';
        const lastName = lastNameInput ? lastNameInput.value.trim() : '';
        const email = emailInput ? emailInput.value.trim() : '';
        const streetAddress = streetAddressInput ? streetAddressInput.value.trim() : '';
        const province = provinceSelect ? provinceSelect.value : '';
        const ward = wardSelect ? wardSelect.value : '';
        
        // Track errors and first error field for focusing
        let firstErrorField = null;
        let hasErrors = false;
        
        // Validate first name
        if (!firstName) {
            const field = showFieldError('contact[first_name]', 'Please fill in this field');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else if (firstName.length > 20) {
            const field = showFieldError('contact[first_name]', 'First name is too long (maximum is 20 characters)');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        }
        
        // Validate last name
        if (!lastName) {
            const field = showFieldError('contact[last_name]', 'Please fill in this field');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else if (lastName.length > 20) {
            const field = showFieldError('contact[last_name]', 'Last name is too long (maximum is 20 characters)');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        }
        
        // Validate email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email) {
            const field = showFieldError('contact[email]', 'Please fill in this field');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else if (!emailRegex.test(email)) {
            const field = showFieldError('contact[email]', 'Please enter a valid email address');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        }
        
        // Validate street address
        if (!streetAddress) {
            const field = showFieldError('address[address1]', 'Please fill in this field');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else if (streetAddress.length > 100) {
            const field = showFieldError('address[address1]', 'Address is too long (maximum is 100 characters)');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        }
        
        // Validate province - check both select value and input value match
        const provinceSearchInput = document.getElementById('address-validator-province-search');
        if (!province) {
            const field = showFieldError('select[name="address[province]"]', 'Please select an item in the list');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else {
            // Validate that select value exists in valid options (prevents autofill bypass)
            if (!validateSelectValueExists('address-validator-province-select')) {
                const field = showFieldError('select[name="address[province]"]', 'Please select an item from the list');
                if (!firstErrorField) firstErrorField = field;
                hasErrors = true;
            } else if (provinceSearchInput && provinceSearchInput.value.trim() !== '') {
                // Validate that input value matches the selected option
                const provinceOption = provinceSelect.options[provinceSelect.selectedIndex];
                if (!provinceOption || provinceOption.textContent.trim().toLowerCase() !== provinceSearchInput.value.trim().toLowerCase()) {
                    const field = showFieldError('select[name="address[province]"]', 'Please select an item from the list');
                    if (!firstErrorField) firstErrorField = field;
                    hasErrors = true;
                }
            }
        }
        
        // Validate ward - check both select value and input value match
        const wardSearchInput = document.getElementById('address-validator-ward-search');
        if (!ward) {
            const field = showFieldError('select[name="address[ward]"]', 'Please select an item in the list');
            if (!firstErrorField) firstErrorField = field;
            hasErrors = true;
        } else {
            // Validate that select value exists in valid options (prevents autofill bypass)
            if (!validateSelectValueExists('address-validator-ward-select')) {
                const field = showFieldError('select[name="address[ward]"]', 'Please select an item from the list');
                if (!firstErrorField) firstErrorField = field;
                hasErrors = true;
            } else if (wardSearchInput && wardSearchInput.value.trim() !== '') {
                // Validate that input value matches the selected option
                const wardOption = wardSelect.options[wardSelect.selectedIndex];
                if (!wardOption || wardOption.textContent.trim().toLowerCase() !== wardSearchInput.value.trim().toLowerCase()) {
                    const field = showFieldError('select[name="address[ward]"]', 'Please select an item from the list');
                    if (!firstErrorField) firstErrorField = field;
                    hasErrors = true;
                }
            }
        }
        
        // Note: Postal Code is auto-filled when Province/City and Ward/Commune are selected, so no validation needed
        
        if (hasErrors) {
            // Focus on first error field and scroll to it
            if (firstErrorField) {
                firstErrorField.focus();
                firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
            return false;
        }
        
        return true;
    }
    
    // Validate and submit form
    async function validateAndSubmit() {
        if (!validateForm()) {
            return;
        }
  
        // Get form values
      const form = document.getElementById('address-validator-form');
        const firstName = form.querySelector('input[name="contact[first_name]"]').value.trim();
        const lastName = form.querySelector('input[name="contact[last_name]"]').value.trim();
        const email = form.querySelector('input[name="contact[email]"]').value.trim();
        const streetAddressInput = form.querySelector('input[name="address[address1]"]');
        const streetAddress = streetAddressInput ? streetAddressInput.value.trim() : '';
        const country = form.querySelector('select[name="address[country]"]').value;
        const provinceSelect = document.getElementById('address-validator-province-select');
        const wardSelect = document.getElementById('address-validator-ward-select');
        const postalCodeInput = form.querySelector('#address-postal-code');
        
        const city = provinceSelect ? provinceSelect.value : '';
        const province = provinceSelect ? provinceSelect.value : '';
        const ward = wardSelect ? wardSelect.value : '';
        const zip = postalCodeInput ? postalCodeInput.value.trim() : '';
        
        // Show loading state
      const submitButton = document.querySelector('#address-validator-submit');
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Processing...';
        }
        
        try {
            // Fetch current cart to get cart items for permalink
            const cartResponse = await fetch(`${Shopify.routes.root}cart.js`);
            const cart = await cartResponse.json();
            
            // Build cart permalink from cart items
            // Format: /cart/variant_id:quantity,variant_id:quantity
            const cartItems = cart.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
        const baseCartUrl = `${Shopify.routes.root}cart/${cartItems}`;
  
            // Build checkout query parameters
            const checkoutParams = new URLSearchParams();
            checkoutParams.append('checkout[email]', email);
            checkoutParams.append('checkout[shipping_address][first_name]', firstName);
            checkoutParams.append('checkout[shipping_address][last_name]', lastName);
            checkoutParams.append('checkout[shipping_address][address1]', streetAddress);
            checkoutParams.append('checkout[shipping_address][address2]', ward);
            checkoutParams.append('checkout[shipping_address][city]', city);
            checkoutParams.append('checkout[shipping_address][province]', province);
            checkoutParams.append('checkout[shipping_address][country]', country);
            checkoutParams.append('checkout[shipping_address][zip]', zip);
            
            // Construct full checkout URL
            const checkoutUrl = `${baseCartUrl}?${checkoutParams.toString()}`;
            
            // Re-enable button before redirect (in case redirect fails or is blocked)
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = 'Continue';
            }
            
            // Redirect to checkout with prefilled data
            window.location.href = checkoutUrl;
        } catch (error) {
            alert('There was an error generating your checkout link. Please try again.');
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = 'Continue';
            }
        }
    }
    
    // Initialize when DOM is ready
    function initialize() {
        // Initialize checkout interception (for cart drawer)
      initCheckoutInterception();
        
        // Initialize address validator form (for validator page)
      initAddressValidatorForm();
    }
  
    // Check if DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
        // DOM is already loaded
      initialize();
    }
  
    // Also listen for dynamically loaded content (cart drawer might load later)
    document.addEventListener('cart:updated', function() {
        initCheckoutInterception();
    });
  })();
  // jsc-reset-scripts.js

